import { addMinutes, getUnixTime, startOfDay } from 'date-fns';

export const dateFnsDayDateToken = 'dd.MM.yyyy';
export const dateFnsDayDateHHmmToken = 'dd.MM.yyyy HH:mm';
export const dateFnsDayDateHHmmssToken = 'dd.MM.yyyy HH:mm:ss';

// convert date to same time in UTC
// (for when time should not change depending on the viewer's timezone)
// e.g. 00:00 +1:00 will be converted to 00:00 +0:00
export function removeTimeZoneOffset(date: Date): Date {
  return addMinutes(date, date.getTimezoneOffset() * -1);
}

// convert a date which has been converted to utc back to the zoned time.
// E.g. unix 0:00 will be eu/zh 0:00
export function addTimeZoneOffset(date: Date): Date {
  return addMinutes(date, date.getTimezoneOffset());
}

export function getUtcStartOfDay(date = new Date()): Date {
  return removeTimeZoneOffset(startOfDay(date));
}

export function getNewUnixTimestamp(): number {
  return getUnixTime(new Date());
}
